import "./App.css";
import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./Components/Screens/Navbar.module.css";
import Home from "./Components/Screens/Home";
import About from "./Components/Screens/About";
import Slide from "react-reveal/Slide";
import { Link } from "react-scroll";
import Skills from "./Components/Screens/Skills";
import Projects from "./Components/Screens/Projects";
import Experience from "./Components/Screens/Experience";
import Education from "./Components/Screens/Education";
import Contact from "./Components/Screens/Contact";
import Footer from "./Components/Footer";

function App() {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <>
      <div className="App">
        <div>
          <div className={styles.mainNavDiv}>
            <Link
              title="Home"
              to="home"
              activeClass="active"
              smooth={true}
              spy={true}
              duration={500}
            >
              <h1 style={{ cursor: "pointer" }}>{"<Hello/>"}</h1>
            </Link>

            <div className={styles.btnSection}>
              <Link
                title="About"
                to="about"
                activeClass="active"
                smooth={true}
                spy={true}
                duration={500}
              >
                <p>{"<About>"}</p>
              </Link>
              <Link
                title="Projects, Experience & Education"
                to="work"
                activeClass="active"
                smooth={true}
                spy={true}
                duration={500}
              >
                <p>{"<My Works>"}</p>
              </Link>
              <Link
                title="Contact"
                to="contact"
                activeClass="active"
                smooth={true}
                spy={true}
                duration={500}
              >
                <p>{"<Contact>"}</p>
              </Link>
              <a
                title="Download resume"
                href="https://drive.google.com/file/d/1QXT-9JL5MIyno8baB2CPJw9FIRfgU8Ey/view"
                target="_blank"
                rel="noreferrer"
              >
                <div className={styles.resumeBtn}>
                  <p>{"Resume()"}</p>
                </div>
              </a>
            </div>
          </div>
          <div className={styles.menuBtnDiv}>
            <h1>{"<Hello/>"}</h1>
            {!showMenu && (
              <MenuIcon
                className={styles.menuBtn}
                onClick={() => {
                  setShowMenu(!showMenu);
                }}
              />
            )}
            {showMenu && (
              <CloseIcon
                className={styles.menuBtn}
                onClick={() => {
                  setShowMenu(!showMenu);
                }}
              />
            )}
          </div>
          <div className={styles.mobileMainNavDiv}>
            {showMenu && (
              <Slide right>
                <div className={styles.mobileBtnSection}>
                  <div className={styles.mobileSecDiv}>
                    <Link
                      className={styles.mobileLink}
                      onClick={() => {
                        setShowMenu(false);
                      }}
                      to="about"
                      activeClass="active"
                      smooth={true}
                      spy={true}
                      duration={500}
                    >
                      <p>{"<About>"}</p>
                    </Link>
                    <Link
                      className={styles.mobileLink}
                      onClick={() => {
                        setShowMenu(false);
                      }}
                      to="work"
                      activeClass="active"
                      smooth={true}
                      spy={true}
                      duration={500}
                    >
                      <p>{"<My Works>"}</p>
                    </Link>
                    <Link
                      className={styles.mobileLink}
                      onClick={() => {
                        setShowMenu(false);
                      }}
                      to="contact"
                      activeClass="active"
                      smooth={true}
                      spy={true}
                      duration={500}
                    >
                      <p>{"<Contact>"}</p>
                    </Link>
                    <a
                      className={styles.mobileLink}
                      onClick={() => {
                        setShowMenu(false);
                      }}
                      href="https://drive.google.com/file/d/1QXT-9JL5MIyno8baB2CPJw9FIRfgU8Ey/view"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className={styles.resumeBtn}>
                        <p>{"Resume()"}</p>
                      </div>
                    </a>
                  </div>
                </div>
              </Slide>
            )}
          </div>
        </div>
        <Link to="#" id="home">
          <Home />
        </Link>
        <Link to="#" id="about">
          <About />
        </Link>
        <Skills />
        <Link to="#" id="work">
          <Projects />
        </Link>
        <Experience />
        <Education />
        <Link to="#" id="contact">
          <Contact />
        </Link>
        <Footer/>
      </div>
    </>
  );
}

export default App;
